import useCurrentUser from 'src/store/user/useCurrentUser';
import { useCurrentProject } from 'src/store';

export default function useViewState() {
  const currentUser = useCurrentUser();
  const currentProject = useCurrentProject();

  return {
    currentUser,
    currentProject,
  };
}
